module.exports = __webpack_public_path__ + "media/react/test_prep/app/pages/score_reports/show/assets/magoosh_ai-b25c8c70d72fdce0450f15d202fc7599.svg";